import React, { useEffect, memo } from 'react';
import { defer } from 'underscore';

const { ApplicationHelper } = window;

export default (
  getScrollContainer = ApplicationHelper.scrollableElement,
) => (WrappedComponent) => memo((props) => {
  useEffect(() => {
    defer(() => {
      const container = getScrollContainer();

      if (container) {
        if (container.scrollTop instanceof Function) {
          // TODO: Function only when jQuery element, we should use Element
          container.scrollTop(0);
        } else {
          container.scrollTop = 0;
        }
      }
    });
  }, []);

  return <WrappedComponent {...props} />;
});
